module.exports = __webpack_public_path__ + "img/01.7678ee19.jpg";